export const ProductPodInstallationDomains = [
  'identifiers',
  'info',
  'installServices',
  'media',
  'details',
  'badges',
  'reviews',
  'availabilityType',
  'pricing',
  'fulfillment',
  'favoriteDetail',
  'sizeAndFitDetail'
];
